module.exports = __webpack_public_path__ + "5f14421cf11c775016a96bc5713284c5.png";